import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
  gap: 0.8rem;

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 9.2rem;
    max-width: 14.2rem;
    height: 12.1rem;
    text-align: center;
  }
  .content:nth-child(2) {
    border-right: 2px solid #b2b2b2;
    border-left: 2px solid #b2b2b2;
    padding: 0 1.4rem;
  }
`;

export const TotalValue = styled.h2`
  margin-bottom: 0.1rem;
  display: flex;
  padding-top: 0.3rem;
  font-size: 3.4rem;
  width: 3.5rem;
  justify-content: center;
  ${(props) => props.color && `border-top: 5px solid ${props.color}`};
`;

export const StatusLabel = styled.h4`
  font-size: 16px;
  color: #808080;
  margin-bottom: 0.1rem;
  display: flex;
`;

export const StatusesBar = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const StatusesBarSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
